import React, { useEffect, useState } from 'react';
import { ArrowForwardIos } from '@material-ui/icons';
import { addDays, getUTCDateString } from '../utils/Functions';
import { TextField, makeStyles, IconButton } from '@material-ui/core';
import { getUTCDate, getWeekEndingDate } from '../utils/TSFunctions';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  textField: {},
  input: {
    color: 'inherit',
    textAlign: 'center',
    margin: 'auto',
    verticalAlign: 'middle',
    width: 'auto',
  },
  icon: {
    fontSize: '25px',
    padding: theme.spacing(1),
    color: 'inherit',
  },
  datePickerContainer: {
    margin: 'auto',
    boxSizing: 'border-box',
  },
  dateInput: {
    padding: '0 ' + theme.spacing(1) + 'px',
    color: 'inherit',
  },
  dense: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  fullWidth: {
    width: '100%',
    display: 'flex',
  },
}));

export interface DateChangerProps {
  parentDate: Date;
  onChange: Function;
  weekEnding?: boolean;
  format?: string;
  className?: string;
  disabled?: boolean;
  dense?: boolean;
  fullWidth?: boolean;
}

export default function DateChanger({ dense = false, fullWidth = false, parentDate, onChange, weekEnding = true, format, className, disabled = false }: DateChangerProps) {
  const classes = useStyles();
  const [date, setDate] = useState<Date>(weekEnding ? getWeekEndingDate(parentDate) : parentDate);
  const dateValue = date.valueOf();
  const parentDateValue = parentDate.valueOf();

  const calendarChange = (event) => {
    let value = event.target.value;
    let parsed = Date.parse(value);
    let parsedDate;
    if (isNaN(parsed)) parsedDate = new Date();
    else parsedDate = new Date(parsed);

    parsedDate = weekEnding ? getWeekEndingDate(parsedDate) : parsedDate;
    setDate(getUTCDate(parsedDate));
  };

  // Moves Date to previous week
  const backWeek = (event) => {
    setDate((date) => {
      return getUTCDate(addDays(date, -7));
    });
  };

  // Moves Date to next week
  const forwardWeek = (event) => {
    setDate((date) => getUTCDate(addDays(date, 7)));
  };

  useEffect(() => {
    if (dateValue !== parentDateValue) {
      onChange(new Date(dateValue));
    }
  }, [dateValue, parentDateValue, onChange]);

  return (
    <div className={clsx(classes.datePickerContainer, className, fullWidth ? classes.fullWidth : '')}>
      <IconButton onClick={backWeek} className={clsx(classes.icon, dense ? classes.dense : '')} style={{ transform: 'rotate(180deg)' }} disabled={disabled}>
        <ArrowForwardIos fontSize='inherit' />
      </IconButton>
      <TextField
        key='weekEndingDate'
        id='date'
        margin='dense'
        size='small'
        type='date'
        onChange={calendarChange}
        value={getUTCDateString(parentDate, format)}
        className={classes.textField}
        inputProps={{
          style: { textAlign: 'center' },
        }}
        InputProps={{
          disableUnderline: true,
          fullWidth: true,
          className: classes.dateInput,
        }}
        disabled={disabled}
      />
      <IconButton onClick={forwardWeek} className={clsx(classes.icon, dense ? classes.dense : '')} disabled={disabled}>
        <ArrowForwardIos fontSize='inherit' />
      </IconButton>{' '}
    </div>
  );
}
